<div
  nz-row
  [nzGutter]="[0, 32]"
>
  <div
    nz-col
    [nzSpan]="24"
  >
    <div nz-row [nzGutter]="[0, 8]">
      <div nz-col [nzSpan]="24">
        <h2
          i18n="@@Level2OTPGeneratorChoice.RequiredSecondLevelAuthentication.Title"
        >
          Richiesta autenticazione di secondo livello
        </h2>
      </div>
      <div nz-col [nzSpan]="24">
        <p
          i18n="@@Level2OTPGeneratorChoice.RequiredSecondLevelAuthentication.Description"
        >
          Per proseguire è necessaria un'ulteriore verifica, scegli il metodo con cui preferisci ricevere il codice
          temporaneo a 8 cifre (OTP):
        </p>
      </div>
    </div>

  </div>
  <div nz-col nzSpan="24">
    <div nz-row [nzGutter]="[0, 8]">
      <div
        nz-col
        nzSpan="24"
        *ngFor="let level2RecognitionType of level2OtpGenerators"
      >
        <app-level2-otp-generator-choice-card
          *ngIf="level2RecognitionType === otpDeliveryMethod.APP && showAuthenticationWithApp"
          [label]="otpRender"
          [icon]="'key'"
          (click)="onClickCard(otpDeliveryMethod.APP)"
        >
          <ng-template #otpRender>
            <ng-container
              i18n="Level2OtpGeneratorChoice.OTPApp.Label"
            >
              Genera OTP sull'app TSiD SPID
            </ng-container></ng-template>
        </app-level2-otp-generator-choice-card>
<!--        <app-level2-otp-generator-choice-card-->
<!--          *ngIf="level2RecognitionType === otpDeliveryMethod.QrCode"-->
<!--          [label]="qrCodeRender"-->
<!--          [icon]="'qrcode'"-->
<!--          (click)="onClickCard(otpDeliveryMethod.QrCode)"-->
<!--        >-->
<!--          <ng-template #qrCodeRender>-->
<!--            <ng-container-->
<!--              i18n="Level2OtpGeneratorChoice.QrCode.Label"-->
<!--            >-->
<!--              Inquadra il QR Code sull'app TSiD SPID-->
<!--            </ng-container></ng-template>-->
<!--        </app-level2-otp-generator-choice-card>-->
        <app-level2-otp-generator-choice-card
          *ngIf="level2RecognitionType === otpDeliveryMethod.EMAIL && showAuthenticationWithApp"
          [label]="emailRender"
          [icon]="'mail'"
          (click)="onClickCard(otpDeliveryMethod.EMAIL)"
        >
          <ng-template #emailRender>
            <ng-container
              i18n="Level2OtpGeneratorChoice.Email.Label"
            >
              Ricevi OTP via email certificata
            </ng-container></ng-template>
        </app-level2-otp-generator-choice-card>
        <app-level2-otp-generator-choice-card
          *ngIf="level2RecognitionType === otpDeliveryMethod.SMS"
          [label]="smsRender"
          [icon]="'phone'"
          (click)="onClickCard(otpDeliveryMethod.SMS)"
        >
          <ng-template #smsRender>
            <ng-container
              i18n="Level2OtpGeneratorChoice.Sms.Label"
            >
              Ricevi OTP via SMS
            </ng-container></ng-template>
        </app-level2-otp-generator-choice-card>
      </div>
    </div>
  </div>
  <div nz-col nzSpan="24">
    <button
      nz-button
      nzType="primary"
      i18n="Level2OtpGeneratorChoice.Button.Back"
      (click)="onBackClick($event)"
    >Indietro</button>
  </div>

</div>
